import { inject } from '@angular/core';
import {
  IsActiveMatchOptions,
  Router,
  ViewTransitionInfo,
} from '@angular/router';
import { LOADING_SERVICE_TOKEN, TLoadingRequest } from '../types';
import { KeyValue } from '@angular/common';

export const executeViewTransition = (transitionInfo: ViewTransitionInfo) => {
  const { transition, to, from } = transitionInfo;
  const router = inject(Router);
  const loadingSvc = inject(LOADING_SERVICE_TOKEN);
  const targetUrl = router.currentNavigation()!.finalUrl!;

  const fromData = from.children?.at(0)?.data;
  const toData = to.children?.at(0)?.data;

  const config: IsActiveMatchOptions = {
    matrixParams: 'ignored',
    queryParams: 'ignored',
    paths: 'subset',
    fragment: 'ignored',
  };
  if (router.isActive(targetUrl, config)) {
    transition.skipTransition();
  } else {
    const loadRequest = toData?.['loader'] as KeyValue<string, TLoadingRequest>;
    if (loadRequest) {
      loadingSvc.registerLoadingKey(loadRequest.key);
      loadingSvc.addLoadRequest(loadRequest.key, loadRequest.value);
    }
    const loadResponse = fromData?.['loader'] as KeyValue<
      string,
      TLoadingRequest
    >;
    if (loadResponse) {
      loadingSvc.setLoadResponse(loadResponse.key);
    }
  }
};
